import React, { useEffect } from 'react';
import FacebookLogin from 'react-facebook-login';
import AppleSignin from 'react-apple-signin-auth';
import { Button, Form, Input } from 'antd';
import env from 'utils/env';
import useLoginApi from './useLoginApi';
import ReCAPTCHA from 'react-google-recaptcha';
import { setItem } from 'utils/local-storage';
import './login.css';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import useLoginV2 from 'hooks/useLoginV2';
import GoogleSignin from 'components/Authentication/GoogleSignin/GoogleSignin';
import { auth, googleProvider } from '../../firebase';
import { signInWithPopup, getAdditionalUserInfo } from 'firebase/auth';

const Login: React.FC = () => {
  const { isLoading, login } = useLoginApi();
  const { elsaIcon, captchaSiteKey, internalApiUrl } = env();
  const { t } = useTranslation();
  useLoginV2();

  const recaptchaRef: any = React.useRef();
  const onSubmitWithReCAPTCHA = async (values: any) => {
    const token = await recaptchaRef.current.executeAsync();
    const form = {
      ...values,
      gCaptcha: token
    };
    login(form);
    setItem('email-login', values.email);
  };

  const responseFacebook = (response: any) => {
    const form = {
      facebook_token: response.accessToken
    }
    login(form);
    setItem('email-login', response.email);
  };

  const responseAppleID = (response: any) => {
    const form = {
      apple_token: response.authorization.code
    }
    login(form);
  };
  const responseGoogle = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      if (user) {
        const token = await user.getIdToken();
        const additionalUserInfo = getAdditionalUserInfo(result);
        const email = user.email || additionalUserInfo?.profile?.email;
        const form = {
          google_token: token,
          google_email: email && typeof email === 'string' ? email.toString() : ''
        }
        console.log(user, additionalUserInfo);
        login(form);
        if (email && typeof email === 'string') {
          setItem('email-login', email);
        }
      }
    } catch (error) {
      console.error('Error during Google login:', error);
    }
};

  const getRedirectUrl = () => {
    const defaultRedirectUrl = `${window.location.origin}/user`;
    const queryParams = new URLSearchParams(window.location.search);
    const redirect = queryParams.get('redirect');
    const redirectUrl = encodeURIComponent(redirect ? defaultRedirectUrl + redirect : defaultRedirectUrl);

    return redirectUrl;
  }

  const getUniversalLoginUrl = () => {
    const redirectUrl = getRedirectUrl();
    return `${env().universalLoginUrl}?clientId=${env().universalLoginClientId}&redirectUrl=${redirectUrl}&lng=vi`;
  };

  const getUniversalResetPasswordUrl = () => {
    const redirectUrl = getRedirectUrl();
    return `${env().universalLoginUrl}/forgot-password?clientId=${env().universalLoginClientId}&redirectUrl=${redirectUrl}&lng=vi`;
  };
  
  return (
    <div className="signin-container">
      <Helmet>
        <title>Login - đăng nhập tài khoản ELSA Speak tại website chính thức</title>
        <meta
          name="description"
          content="Hướng dẫn login (đăng nhập) tài khoản ELSA Speak trên website chính thức để kích hoạt mã code, update tài khoản ELSA miễn phí lên ELSA Pro, ELSA Premium"
        />
      </Helmet>
      <div className="logo">
        <img alt="logo" src={elsaIcon} />
      </div>

      <div className="form-container">
        <h1 className="login-title">{t('login.page_title')}</h1>
        <Button
          className="submit-button"
          onClick={() => {
            window.location.href = getUniversalLoginUrl();
          }}
        >
          {t('login.login')}
        </Button>

        <div className="form-login-footer">
          <a href={getUniversalResetPasswordUrl()}>
            <button className="footer-link" >{t('login.forgot_password')}</button>
          </a>
          <a href={getUniversalLoginUrl()}>
            <button className="footer-link" >
            {t('signup.signup')}
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Login;
